import { connect } from 'react-redux';
import SearchBox from '../components/SearchBox';
import { setModalSearchBoxState } from '../actions/SearchBoxAction';


const mapStateToProps = (state) => ({
    modalSearchBoxIsOpen: state.search.modalSearchBoxIsOpen,
});

const mapDispatchToProps = (dispatch) => ({
    setModalSearchBoxState: (isOpen = false) => {
        dispatch(setModalSearchBoxState(isOpen));
    },
});

const SearchBoxContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchBox);

export default SearchBoxContainer;
